<template>
  <div class="col-lg-4" v-if="movieDetail">
        <div class="movie-side-info-box">
        <figure><img :src="uploads+movieDetail.poster" alt="Image"></figure>
       <ul>
        <li v-if="movieDetail.dt"><strong> Release Date: </strong> {{ movieDetail.dt }}</li>
<li v-if="movieDetail.dir"><strong>Director:</strong>{{ movieDetail.dir }}</li>
<li v-if="movieDetail.prod"> <strong>Producer:</strong> {{ movieDetail.prod }}</li>
         </ul>
        </div>
        <!-- end movie-side-info-box -->
      </div>
</template>



<script>
import { UPLOADS } from '@/conf';
export default {
  props: {
		movieDetail: Object,
	},
  data() {
    return {
      imgPath: process.env.BASE_URL,
      uploads:UPLOADS
    }
  },

}

</script>